import { render } from "./Sample.vue?vue&type=template&id=19f9c64f"
const script = {}

import exportComponent from "/usr/src/app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__